var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nkn-miner"},[_c('div',[_c('div',{staticClass:"nkn-container"},[_c('miner-intro')],1),_vm._v(" "),_c('div',{staticClass:"nkn-container"},[_c('miner-node-software')],1),_vm._v(" "),_c('div',{staticClass:"nkn-container"},[_c('miner-resources')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75cd06d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MinerPortal.vue
// module id = null
// module chunks = 